import React from "react";
import { Link, withRouter } from "react-router-dom";
import { Input, FormGroup } from "reactstrap";

const Columns = (addUpd, destroy, active, setModalChangePassw, authUser) => {
  let columns = [
    {
      id: "name",
      name: "Nombre",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      id: "email",
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      id: "profile",
      name: "Perfil",
      selector: (row) => row.profile_name,
      width: "150px",
    },
    {
      id: "phone_validated",
      name: "Teléfono validado",
      selector: (row) => row.phone_validated ? <i className="fas fa-check text-success"></i> : <i className="fas fa-times text-secondary"></i>,
      width: "150px",
      center: true,
    },
    {
      id: "active",
      name: "Activo",
      width: "100px",
      cell: (row) => (
        <div className="d-flex justify-content-between">
          <FormGroup switch>
            <Input
              type="switch"
              defaultChecked={row.active}
              onClick={() => {
                active(row);
              }}
            />
          </FormGroup>
        </div>
      ),
    },
    {
      id: "actions",
      name: "Acciones",
      button: true,
      width: "150px",
      cell: (row) => (
        <>
          <div className="p-2">
            <button
              className="btn btn-primary btn-sm"
              title="Editar usuario"
              onClick={() => addUpd(row)}
            >
              <i className="fas fa-edit"></i>
            </button>
          </div>

          <div className="p-2">
            <button
              className="btn btn-primary btn-sm"
              title="Cambiar contraseña"
              onClick={() => setModalChangePassw({ show: true, id: row.id })}
            >
              <i className="fa fa-key"></i>
            </button>
          </div>

          <div className="p-2">
            <button
              className="btn btn-danger btn-sm"
              title="Eliminar usuario"
              onClick={() => destroy(row.id)}
            >
              <i className="fas fa-trash"></i>
            </button>
          </div>

          <div className="p-2">
            <Link
              to={`/users/profile/${row.id}`}
              className="btn btn-primary btn-sm"
              title="Perfil de usuario"
            >
              <i className="fa fa-address-book"></i>
            </Link>
          </div>
        </>
      ),
    },
  ];

  if (authUser.profile_id == 2) {
    columns = [
      {
        id: "ruta",
        name: "Ruta",
        selector: (row) => row.route?.name,
        sortable: true,
      },
      ...columns,
    ];
  }

  return columns;
};

export default Columns;
